import { render, staticRenderFns } from "./StandardsAccordion.vue?vue&type=template&id=32dbc899"
import script from "./StandardsAccordion.vue?vue&type=script&lang=js"
export * from "./StandardsAccordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports